import _ from 'lodash';
import history from '../../lib/history';
import * as at from './actionTypes';
import {
  addEntries
} from 'data/actions';
import { makeDebugger } from 'lib';

const debug = makeDebugger('scenes/EntriesAddModal/actions');

export const cancelAdding = () => {
  return {
    type: at.CANCEL_ADDING
  }
}

export const entryRemove = (url) => {
  return {
    type: at.ENTRY_REMOVE,
    payload: url
  }
}

export const tagsUpdatedInSelection = (newTags) => {
  return (dispatch, getState) => {
    dispatch({ type: at.TAGS_UPDATED_IN_SELECTION, payload: newTags });
  }
}

export const openModalWithEntries = (entries) => {
  return (dispatch, getState) => {
    dispatch({ type: at.OPEN_MODAL, payload: entries})
    // If the modal is already open, don't push another modal...
    if (history.location.pathname !== '/modal/entries/add') {
      history.push('/entries/add', { modal: true });
    }
  }
}

export const doneEditing = (tags, entries) => {
  return (dispatch, getState) => {
    debug('done editing')
    debug('tags to add to entry: ', tags);
    const entriesWithTags = _.map(entries, (entry) => {
      return { ...entry, tags}
    })
    debug('adding entries: ', entriesWithTags);
    dispatch(addEntries(entriesWithTags))
    dispatch({ type: at.DONE_EDITING });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/EntriesAddModal/actions.js